import React from 'react';
import { List } from 'semantic-ui-react';
import clsx from 'clsx';
import FormListItems from './FormListItems';

const FormFieldList = ({
  canEdit,
  category,
  children,
  className,
  code,
  component,
  direction,
  fields,
  hideLabel,
  isEditing,
  onChange,
  saveErrors,
  saveStatus,
  section,
  showEdit,
  text,
}) => (
  <List className={clsx('aridhia-form-field-list', className, `section_${section}`)}>
    <FormListItems
      canEdit={canEdit}
      category={category}
      code={code}
      component={component}
      direction={direction}
      fields={fields}
      hideLabel={hideLabel}
      isEditing={isEditing}
      onChange={onChange}
      saveErrors={saveErrors}
      saveStatus={saveStatus}
      section={section}
      showEdit={showEdit}
      text={text}
    />
    {children}
  </List>
);

export default FormFieldList;
